<h1 mat-dialog-title>{{ data.name }}</h1>

<textarea class="key-textarea" ixTest="certificate" readonly>{{ data.certificate }}</textarea>

<div mat-dialog-actions class="actions">
  <ix-copy-btn [text]="data.certificate"></ix-copy-btn>
  <button mat-button type="button" ixTest="close" (click)="dialogRef.close()">
    {{ 'Close' | translate }}
  </button>
  <button
    mat-button
    color="primary"
    type="button"
    ixTest="download-certificate"
    (click)="onDownloadPressed()"
  >
    {{ 'Download' | translate }}
  </button>
</div>
